export default () => {
    return [
        {
            path: '/mappa',
            name: 'mappa',
            component: () => import('./views/mappa.vue'),
        },
    ];
};
